// extracted by mini-css-extract-plugin
export default {"sidebar-item":"components-parity-parity-manager-sidebar-item-module__sidebar-item"};